import { getActionHandler, getInitialState } from "../helpers/crudReducers";

const initialState = getInitialState("PROPOSAL_ACCOUNTS");
const CRUD_ACTION_HANDLERS = getActionHandler("PROPOSAL_ACCOUNTS");

export default function proposalAccounts(state = initialState, action) {
  const handler = CRUD_ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
